import { useQuery } from "react-query";
import AccessControlService from "../../services/access-control-service/AccessControlService";
import { RestError } from "../../services/rest-service/RestService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { keys } from "./Keys";
import { IAccessFunctionalityData } from "../../common/models/IAccessFunctionalityData";

export type UseAccessFunctionalityDataParameters = {
    groupID: number;
} & BaseUseQueryParameters<IAccessFunctionalityData>;

export function useAccessFunctionalityData({
    groupID,
    enabled,
    onError,
    onSuccess
}: UseAccessFunctionalityDataParameters) {
    return useQuery<IAccessFunctionalityData, RestError>(
        keys.accessFunctionalityData(groupID),
        ({ signal }) => {
            return AccessControlService.getAccessFunctionalityData(groupID, signal);
        },
        {
            enabled,
            onError,
            onSuccess
        }
    );
}
